<template>
  <div class="home-page">
    <b-overlay :show="isLoading" variant="light" blur="2px">

      <section class="hero-section">
        <div class="hero-content">
          <h1 class="hero-title">Portal B2B</h1>
          <p class="hero-subtitle">Selecione uma marca para explorar nosso catálogo de produtos</p>
        </div>
      </section>

      <section class="brands-section">
        <div class="section-header">
          <span class="section-badge">Nossas Marcas</span>
          <h2 class="section-title">Escolha sua marca preferida</h2>
          <p class="section-description">Selecione uma marca para visualizar os produtos disponíveis</p>
        </div>

        <b-row class="justify-content-center">
          <b-col cols="12" lg="11" xl="10" class="banner-container">
            <div class="banner-wrapper">
              <b-img
                src="@/assets/images/BANNER-B2B-MARCAS.png"
                class="banner-image"
                fluid
                alt="Banner B2B Marcas"
              />

              <div class="clickable-overlay">
                <div
                  class="clickable-zone zona-zorba"
                  @click="goToProdutoPorMarca({ id: 10, nome: 'Zorba' })"
                  title="Zorba"
                >
                  <span class="brand-label">Zorba</span>
                </div>

                <div
                  class="clickable-zone zona-hanes"
                  @click="goToProdutoPorMarca({ id: 80, nome: 'Hanes' })"
                  title="Hanes"
                >
                  <span class="brand-label">Hanes</span>
                </div>

                <div
                  class="clickable-zone zona-kendall"
                  @click="goToProdutoPorMarca({ id: 20, nome: 'Kendall' })"
                  title="Kendall"
                >
                  <span class="brand-label">Kendall</span>
                </div>

                <div
                  class="clickable-zone zona-tensor"
                  @click="goToProdutoPorMarca({ id: 30, nome: 'Tensor' })"
                  title="Tensor"
                >
                  <span class="brand-label">Tensor</span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </section>

      <view-pic-generica v-if="picGenereca.length > 0"/>

      <section class="highlights-section" v-if="homeService.sLSFamiliaComercialService.store.getters['slsFamiliaComercial/getProdutosDestaque'] && homeService.sLSFamiliaComercialService.store.getters['slsFamiliaComercial/getProdutosDestaque'].length > 0">
        <div class="section-header">
          <span class="section-badge">Em Destaque</span>
          <h2 class="section-title">Produtos Recomendados</h2>
          <p class="section-description">Confira nossa seleção especial de produtos!</p>
        </div>

        <b-row class="products-grid">
          <b-col
            v-for="produto in homeService.sLSFamiliaComercialService.store.getters['slsFamiliaComercial/getProdutosDestaque']"
            :key="produto.id"
            cols="12"
            sm="6"
            lg="3"
            class="mb-4"
          >
            <div class="product-card" @click="getPrioridadePadraoPedido(produto)">
              <div class="product-image-wrapper">
                <img
                  :src="produto.caminho"
                  :alt="produto.Descricao"
                  class="product-image"
                />
                <div class="product-overlay">
                  <span class="view-details">Ver Detalhes</span>
                </div>
              </div>
              <div class="product-info">
                <h4 class="product-name">{{ produto.Descricao }}</h4>
              </div>
            </div>
          </b-col>
        </b-row>
      </section>

    </b-overlay>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive';
import HomeService from '@/services/home.service';
import SLSEsPrioriService from '@/services/SistemaDKP/SLSEsPriori.service';
import SLSParametrosService from '@/services/SistemaDKP/SLSParametros.service';
import { useWindowSize } from '@vueuse/core';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { BImg } from 'bootstrap-vue';
import 'swiper/css/swiper.css';
import ViewPicGenerica from '@/views/home/components/viewPicGenerica.vue';
import { mapGetters } from 'vuex';

const slsParametrosService = new SLSParametrosService();
const homeService = new HomeService();
const slsEsPrioriService = new SLSEsPrioriService();

const { width, height } = useWindowSize();

export default {
  name: 'CatalogoProdutos',
  directives: {
    Ripple,
  },
  components: {
    ViewPicGenerica,
    Swiper,
    SwiperSlide,
    BImg,
  },
  data() {
    return {
      isMobile: false,
      swiperOption: {
        slidesPerView: 5,
        slidesPerColumn: 1,
        spaceBetween: 20,
      },
      homeService,
      width,
      height,
    };
  },
  computed: {
    ...mapGetters('PicStore', {
      picGenereca: 'GET_PIC_GENERICAS',
    }),
    ...mapGetters('InfoPedido', {
      isLoading: 'GET_IS_LOADING',
    }),
  },
  created() {
    this.checkIfMobile();
    window.addEventListener('resize', this.checkIfMobile);
  },
  destroyed() {
    window.removeEventListener('resize', this.checkIfMobile);
  },
  methods: {
    async getPrioridadePadraoPedido(prod = null) {
      try {
        if (prod) {
          this.$store.commit('InfoPedido/SET_ITEM_SELECTED', prod);
          this.$store.commit('InfoPedido/SET_IS_LOADING', true);
          this.$root.$emit('infoPedido:checkGrade');
        }
        await slsEsPrioriService.selectPrioridadePedido();
        const prioridadePadrao = await slsParametrosService.findByDescricao('PARAM_PRIORIDADE_PADRAO');
        if (prioridadePadrao) {
          this.$store.commit('InfoPedido/SET_PRIORIDADE_PEDIDO_FORM', prioridadePadrao.parametro_valor);
        }
      } catch (error) {
        console.error('Erro ao obter prioridade padrão do pedido:', error);
      } finally {
        this.$store.commit('InfoPedido/SET_IS_LOADING', false);
      }
    },
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    goToProdutoPorMarca(marca) {
      this.$router.push({
        name: 'produtos-catalogo-marca',
        params: {
          codMarca: marca.id,
        },
      });
    },
  },
  mounted() {
    this.homeService.loadingDadosHome();
    this.getPrioridadePadraoPedido();
  },
};
</script>

<style scoped lang="scss">
@import '@/views/home/styles/index.scss';

// ============================================
// HOME PAGE - Premium B2B Theme-Aware Styles
// ============================================

.home-page {
  background: var(--sf-body-bg, #f5f7fa);
  min-height: 100vh;
}

// ============================================
// HERO BANNER - High Contrast with Overlay
// ============================================
.hero-section {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  padding: 3.5rem 2rem;
  margin: -1.5rem -1.5rem 0 -1.5rem;
  text-align: center;
  position: relative;
  overflow: hidden;

  // Dark overlay for better text legibility
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0.35) 50%, rgba(0, 0, 0, 0.25) 100%);
    z-index: 0;
  }

  // Subtle pattern overlay
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.5;
    z-index: 0;
  }
}

.hero-content {
  position: relative;
  z-index: 2;
}

.hero-title {
  font-size: 2.75rem;
  font-weight: 800 !important;
  color: rgba(255, 255, 255, 0.98) !important;
  margin-bottom: 0.75rem;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5), 0 4px 16px rgba(0, 0, 0, 0.3) !important;
  opacity: 1 !important;
}

.hero-subtitle {
  font-size: 1.15rem;
  color: rgba(255, 255, 255, 0.85) !important;
  margin: 0;
  font-weight: 500 !important;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.4) !important;
  opacity: 1 !important;
}

// ============================================
// CONTENT CONTAINER - Visual Hierarchy Panel
// ============================================
.brands-section {
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 1.5rem 3.5rem;
  background: var(--sf-surface-bg, #ffffff);
  border-radius: 20px 20px 0 0;
  margin-top: -1.5rem;
  position: relative;
  z-index: 2;
  box-shadow: 0 -4px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--sf-border-light, #e5e8f0);
  border-bottom: none;
}

// ============================================
// SECTION HEADER - Refined Typography
// ============================================
.section-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.section-badge {
  display: inline-block;
  background: var(--sf-accent-bg, rgba(115, 103, 240, 0.12));
  color: var(--sf-accent-dark, #5147d3);
  padding: 0.35rem 1rem;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 1rem;
  border: 1px solid var(--sf-accent, rgba(115, 103, 240, 0.2));
}

.section-title {
  font-size: 1.85rem;
  font-weight: 700;
  color: var(--sf-text-primary, #2f2b3d);
  margin: 0 0 0.5rem 0;
  line-height: 1.3;
}

.section-description {
  font-size: 0.95rem;
  color: var(--sf-text-muted, #5f6472);
  margin: 0.75rem 0 0 0;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

// ============================================
// BANNER CONTAINER - Premium Card Style
// ============================================
.banner-container {
  position: relative;
  margin-bottom: 1rem;
  animation: fadeInUp 0.8s ease-out;
}

.banner-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  border-radius: 16px;
  overflow: hidden;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.04),
    0 10px 20px rgba(0, 0, 0, 0.08),
    0 20px 40px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--sf-border-light, #e5e8f0);
  background: var(--sf-surface-bg, #ffffff);
}

.banner-image {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.5s ease;
}

.banner-wrapper:hover .banner-image {
  transform: scale(1.02);
}

// ============================================
// CLICKABLE BRAND ZONES - Interactive Cards
// ============================================
.clickable-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
}

.clickable-zone {
  height: 100%;
  cursor: pointer;
  position: relative;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  border-right: 1px solid rgba(255, 255, 255, 0.1);

  &:last-child {
    border-right: none;
  }

  // Hover state - elevated with gradient
  &:hover {
    // background: linear-gradient(
    //   to top,
    //   rgba(0, 0, 0, 0.5) 0%,
    //   rgba(0, 0, 0, 0.2) 40%,
    //   transparent 70%
    // );

    .brand-label {
      opacity: 1;
      transform: translateY(0) scale(1.05);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
    }
  }

  // Active/pressed state
  &:active {
    .brand-label {
      transform: translateY(0) scale(0.98);
    }
  }
}

// Brand label badge - always visible with better contrast
.brand-label {
  position: absolute;
  bottom: 1.25rem;
  color: #ffffff;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.6rem 1.25rem;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(12px);
  border-radius: 8px;
  opacity: 0.85;
  transform: translateY(0);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 1.2px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

// Zone widths (matching banner image layout)
.zona-zorba {
  width: 27.3%;
  flex: none;
}

.zona-hanes {
  width: 21.6%;
  flex: none;
}

.zona-kendall {
  width: 21.3%;
  flex: none;
}

.zona-tensor {
  width: 29.8%;
  flex: none;
}

// ============================================
// HIGHLIGHTS SECTION - Product Grid
// ============================================
.highlights-section {
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 1.5rem 3.5rem;
  background: var(--sf-surface-bg, #ffffff);
  border: 1px solid var(--sf-border-light, #e5e8f0);
  border-top: none;
  border-radius: 0 0 20px 20px;
}

.products-grid {
  max-width: 1200px;
  margin: 0 auto;
}

// ============================================
// PRODUCT CARDS - Theme-Aware
// ============================================
.product-card {
  background: var(--sf-card-bg, #ffffff);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: var(--sf-shadow-sm, 0 2px 8px rgba(20, 32, 63, 0.06));
  border: 1px solid var(--sf-border-light, #e5e8f0);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  height: 100%;

  &:hover {
    transform: translateY(-6px);
    box-shadow:
      var(--sf-shadow-md, 0 4px 16px rgba(20, 32, 63, 0.08)),
      0 12px 28px rgba(115, 103, 240, 0.12);
    border-color: var(--sf-accent, #7367f0);

    .product-image {
      transform: scale(1.06);
    }

    .product-overlay {
      opacity: 1;
    }
  }
}

.product-image-wrapper {
  position: relative;
  overflow: hidden;
  background: var(--sf-surface-secondary, #eef1f8);
  aspect-ratio: 1;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 1rem;
  transition: transform 0.5s ease;
}

.product-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(102, 126, 234, 0.95), transparent);
  padding: 2rem 1rem 1rem;
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
}

.view-details {
  color: white;
  font-weight: 600;
  font-size: 0.85rem;
  padding: 0.5rem 1.25rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.product-info {
  padding: 1.25rem;
  text-align: center;
  border-top: 1px solid var(--sf-border-light, #e5e8f0);
  background: var(--sf-card-bg, #ffffff);
}

.product-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--sf-text-primary, #2f2b3d);
  margin: 0;
  line-height: 1.4;
}

// ============================================
// ANIMATIONS
// ============================================
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// ============================================
// RESPONSIVE BREAKPOINTS
// ============================================
@media (max-width: 1200px) {
  .brands-section,
  .highlights-section {
    margin-left: 1rem;
    margin-right: 1rem;
    max-width: calc(100% - 2rem);
  }
}

@media (max-width: 992px) {
  .hero-title {
    font-size: 2.25rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .section-title {
    font-size: 1.5rem;
  }

  .brands-section,
  .highlights-section {
    padding: 2rem 1.25rem 2.5rem;
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding: 2.5rem 1.5rem;
    margin: -1rem -1rem 0 -1rem;
  }

  .hero-title {
    font-size: 1.85rem;
  }

  .brands-section,
  .highlights-section {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    max-width: calc(100% - 1rem);
    border-radius: 16px 16px 0 0;
  }

  .highlights-section {
    border-radius: 0 0 16px 16px;
  }

  .brand-label {
    font-size: 0.7rem;
    padding: 0.45rem 0.9rem;
    bottom: 0.75rem;
  }

  .banner-wrapper {
    border-radius: 12px;
  }

  .product-card {
    margin-bottom: 1rem;
  }
}

@media (max-width: 576px) {
  .hero-title {
    font-size: 1.5rem;
  }

  .hero-subtitle {
    font-size: 0.9rem;
  }

  .section-badge {
    font-size: 0.65rem;
    padding: 0.25rem 0.75rem;
  }

  .section-title {
    font-size: 1.25rem;
  }

  .brand-label {
    font-size: 0.55rem;
    padding: 0.3rem 0.6rem;
    bottom: 0.5rem;
    letter-spacing: 0.8px;
  }

  .brands-section,
  .highlights-section {
    padding: 1.5rem 1rem 2rem;
  }
}
</style>
